import cartDropdownHtml from './cartdropdown.component.html';
import './cartdropdown.component.scss';

class CartDropdownController {
    constructor($scope, $rootScope, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.service = CartService;
    }

    $onInit() {
        this.$rootScope.$on('dropdown-open', (event, id) => {
            if (this.loadOn != id) return;

            if (!this.service.loaded && !this.service.loading) {
                this.service.load();
            }
        });
    }
}

let cartDropdownComponent = {
    bindings: {
        loadOn: '@'
    },
    template: cartDropdownHtml,
    controller: CartDropdownController
}

export default cartDropdownComponent;
